import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Const} from '../const/const';
import {Observable, of} from 'rxjs';
import {ResultApplication} from '../models/result-application.model';
import {ApplicationModel} from '../models/application.model';
import {map} from 'rxjs/operators';
import {ResultModel} from "../models/result.model";
import {JobAd} from "../models/job-ad.model";


@Injectable({
  providedIn: 'root'
})
export class ControlPanelService {
    constructor(private http: HttpClient) {}

    getApplicansNumber(questionId: number, min: number, max: number, note: string): Observable<ResultApplication<ApplicationModel>> {
      return this.http.get<ResultApplication<ApplicationModel>>(Const.baseAPI + '/get-applicants-number?question_id=' + questionId + '&min=' + min + '&max=' + max + '&note=' + note);
    }

    getApplicantCheckbox(question_id: number, number: number, answers: any): Observable<ResultApplication<ApplicationModel>> {
      return this.http.get<ResultApplication<ApplicationModel>>(Const.baseAPI + '/get-applicant-checkbox?question_id=' + question_id + '&answers=' + answers + '&number=' + number);
    }

    getApplicantsFull(data: any): Observable<ResultApplication<ApplicationModel>> {
        return this.http.post<ResultApplication<ApplicationModel>>(Const.baseAPI + '/get-applicant-full', data);
    }

    getControlPanelDetail(job_ad_id: number, finalization_id: number, currentLang: string): Observable<ResultModel<JobAd>> {
        return this.http.get<ResultModel<JobAd>>(Const.baseAPI + '/get-control-panel-detail?job_ad_id=' + job_ad_id + '&finalization_id=' + finalization_id + '&currentLang=' + currentLang);
    }

    getApplicationHasRules(data: any) {
        return this.http.post(Const.baseAPI + '/get-application-has-rules', data);
    }

    saveControlPanelSettings(data: any) {
        return this.http.post(Const.baseAPI + '/save-control-panel-settings', data);
    }

    getControlPanelSettings(job_ad_id: number, finalization_id: number) {
        return this.http.get(Const.baseAPI + '/get-control-panel-settings?job_ad_id=' + job_ad_id + '&finalization_id=' + finalization_id);
    }

    getPreviewApplicantTable(arrUserId: any) {
        return this.http.post(Const.baseAPI + '/get-preview-applicant-table', arrUserId);
    }

    downloadPreliminary(data: any, job_id: number, currentLang: string): Observable<boolean> {
        const url = Const.baseAPI + '/downloadPreliminaryTable?jobId=' + job_id + '&lang=' + currentLang + '&data=' + data;
        window.open(url);
        return of(true);
    }
}

